import { render, staticRenderFns } from "./QAccountGrants.vue?vue&type=template&id=766f229f&scoped=true&"
import script from "./QAccountGrants.vue?vue&type=script&lang=js&"
export * from "./QAccountGrants.vue?vue&type=script&lang=js&"
import style0 from "./QAccountGrants.vue?vue&type=style&index=0&id=766f229f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766f229f",
  null
  
)

export default component.exports